var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOdontoConectaSmall = function SvgOdontoConectaSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.77 6.05c-.68 1.42-.11 2.91-1.34 4.08-2.71 2.57-6.4-1.92-3.6-4.31 1.27-1.09 3.11-.79 4.06.58l.63-1.37c-3.03-3.19-8.14 0-6.8 4.35 1.02 3.31 5.39 3.92 7.27 1.01 1.08-1.66.16-3.65 1.96-4.8C12.27 4.1 15 6.64 13.89 9.22c-.84 1.97-3.6 2.2-4.74.4l-.68 1.28c2.21 2.73 6.69 1.13 7-2.42.42-4.78-5.72-6.54-7.71-2.42Z"
  })));
};
export default SvgOdontoConectaSmall;